import { sortByKey } from '@/utils/arrayHelpers';

export const filterOptions = (options, filter) => {
  const sortKey = options.length > 0 && options[0].hasOwnProperty('sortValue') ? 'sortValue' : 'label';
  const sortedOptions = sortByKey([...options], sortKey, true);
  return sortedOptions.filter(option => option[sortKey].toLowerCase().includes(filter.toLowerCase()));
};
